import React from 'react';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import {useManageContext} from "../App";
import Icon from "@mdi/react";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {

    const {toast, setToast} = useManageContext();

    return (
        <ToastContainer position="top-center" className="mt-3" style={{zIndex: 1}}>
            <Toast bg={toast?.type} onClose={() => setToast(null)} show={toast !== null} delay={2000} autohide>
                {toast && <Toast.Body><Icon path={toast.iconPath} size={1}/> {toast.text}</Toast.Body>}
            </Toast>
        </ToastContainer>
    );
}